// src/App.js
import React, { useState, useEffect } from 'react';
import { collection, addDoc, onSnapshot, updateDoc, doc, deleteDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "./firebase"; // Firebase config file
import NameForm from './NameForm';
import NameTable from './NameTable';
import './App.css';
import logo from './logo1.png';

function App() {
  const [people, setPeople] = useState([]);

  // 🔥 Firestore: Real-time sync across all devices
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "beerlist"), (snapshot) => {
      const peopleData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPeople(peopleData);
    });

    return () => unsubscribe(); // Cleanup listener
  }, []);

  const addPerson = async (person) => {
    if (person.name.trim() !== "" && person.beers > 0) {
      const peopleRef = collection(db, "beerlist");
      const q = query(peopleRef, where("name", "==", person.name));

      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        // Person exists, update beer count
        querySnapshot.forEach(async (docSnap) => {
          const existingPerson = docSnap.data();
          await updateDoc(doc(db, "beerlist", docSnap.id), {
            beers: existingPerson.beers + person.beers
          });
        });
      } else {
        // Add new entry
        await addDoc(peopleRef, person);
      }
    }
  };

  const handleNameClick = async (id, beers) => {
    if (beers > 1) {
      await updateDoc(doc(db, "beerlist", id), {
        beers: beers - 1
      });
    } else {
      await deleteDoc(doc(db, "beerlist", id));
    }
  };

  return (
    <div className="App">
      <img src={logo} alt="Logo" className="logo" />
      <h1>Beer List</h1>
      <NameForm onAddPerson={addPerson} />
      <NameTable people={people} onNameClick={handleNameClick} />
    </div>
  );
}

export default App;
